import { render, staticRenderFns } from "./toinvoice.vue?vue&type=template&id=46f65771&scoped=true"
import script from "./toinvoice.vue?vue&type=script&lang=js"
export * from "./toinvoice.vue?vue&type=script&lang=js"
import style0 from "./toinvoice.vue?vue&type=style&index=0&id=46f65771&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f65771",
  null
  
)

export default component.exports